<style lang="less" scoped>
    @import '~@/assets/less/common/common.less';
    @import '~@/assets/less/article/index.less';
    @import '~@/assets/less/article/pc.less';
    @import '~@/assets/less/common/helper.less';
    @import '~@/assets/less/common/icon.less';
    @import '~@/assets/less/article/mobile.less';
</style>
<style lang="less">
    @import '~@/assets/less/components/tinymce-content.less';
    @import '~@/assets/less/article/mobile_tinymce.less';
    @import '~@/assets/less/components/basic.less';
</style>

<template>
  <div id="app" class="pc_container" :class="[isMobile ?  'mobile_container' : '']">

    <section class="content_area" v-if="!isFile">
        <div class="top_area">
          <p class="article_title">{{articleTitle}}</p>
          <div class="article_info">
            <span>{{articleCompany}}</span>
            <span>{{articleAuthor}}</span>
            <span>{{articleTime}}</span>
            <span>浏览({{pageCount}})</span>
          </div>
        </div>

        <div class="rich_area mce-content-body no-margin image-viewer" v-html="content" v-if="content && !isMobile" v-highlight v-lazy-load v-videos v-audios></div>
        <div class="rich_area mce-content-body no-margin" v-html="content" v-if="content && isMobile" v-highlight v-tencent-videos v-lazy-load v-audios></div>
    </section>

    <section class="content_area doc-view" v-if="isFile && target">
        <div class="top_area">
          <p class="article_title">{{articleTitle}}</p>
          <div class="article_info">
            <span>{{articleCompany}}</span>
            <span>{{articleAuthor}}</span>
            <span>{{articleTime}}</span>
            <span>浏览({{pageCount}})</span>
          </div>
        </div>

        <section class="file_preview_area">
          <file-preview :target="target" :target-type="target.type" :is-mobile="isMobile"></file-preview>
        </section>
    </section>


    <section class="attachment_download_area" v-if="!isFile && attachments.length">
      <p class="attachment_line">附件</p>
      <ul>
          <li class="attachment-list clearfix previewable" v-for="attachment in attachments">
              <div  class="icon-lg-doc-type bg-sprites mr-m" :class="[iconMap[attachment.type] || 'icon-lg-attachment']" ></div> 
              <div  class="information">
                  <div  class="single-line">{{attachment.name}}</div> 
                  <div class="secondary">{{attachment.size}}</div>
              </div> 
              <div class="action">
                <a target="_blank" :href="attachment.url" v-if="!isMobile">
                下载
                </a>
                <a :href="attachment.url" v-if="isMobile">
                下载
                </a>
              </div>
          </li>
      </ul>
    </section>

    <section class="error_area" v-if="errorTips">
      <div>{{errorTips}}</div>
    </section>
  </div>
</template>

<script>

import '@/lib/vue.directive.js';
import filePreview from '@/components/preview.vue';
import axios from 'axios';
import cookieClient from 'js-cookie';

export default {
  name: 'articlePage',

  data () {
    return {
      device : {},
      isMobile: false,
      articleTitle: "",
      articleCompany: "",
      articleAuthor: "",
      articleTime: "",
      obj: null,
      errorTips: "",
      showAttachment: true,
      isFile: false,
      target: null,
      attachments: [],
      iconMap: {
        "pdf": "icon-lg-pdf",

        "ppt": "icon-lg-ppt",
        "pptx": "icon-lg-ppt",
        "dps": "icon-lg-ppt",

        "xls": "icon-lg-xls",
        "xlsx": "icon-lg-xls",
        "xlsm": "icon-lg-xls",
        "et": "icon-lg-xls",

        "doc": "icon-lg-doc",
        "docx": "icon-lg-doc",
        "wps": "icon-lg-doc",
        "rtf": "icon-lg-doc",


        "txt": "icon-lg-txt",
        "attachment": "icon-lg-attachment"
      },

      content: "",
      pageCount: 0,
      companyId: "",
      tType: "",
      tId: "",
      domain: "",
      fdomain: "",

    };
  },

  components: {
    filePreview
  },

  created () {
    this.domain = (window.location.hostname || "").replace("mp","mpapi");
    this.fdomain = this.domain.replace("mpapi","");
    let ua = (navigator.userAgent || "").toLowerCase();
    let device = {};
    device.isAndroid = ua && ua.indexOf('android') > 0;
    device.isIOS = ua && /iphone|ipad|ipod|ios/.test(ua);
    device.isMicromessenger = ua && ua.indexOf('micromessenger') > 0;
    device.isWechat = device.isMicromessenger && ua.indexOf('wxwork') === -1;
    device.isWxwork = device.isMicromessenger && ua.indexOf('wxwork') > 0;
    device.isGovWxwork = device.isMicromessenger && ua.indexOf('wxworklocal') > 0;
    this.isMobile = device.isMobile = device.isAndroid || device.isIOS;
    device.isPc = device.isMicromessenger && !device.isMobile;
    device.isMac = ua && ua.indexOf('mac') > 0;

    let obj = this.obj = window.cosObj || null;
    if(!this.obj || typeof obj.isFile == "undefined"){
      this.errorTips = "获取COS数据错误，请稍后再试。";
      return;
    }
    this.articleTitle = obj.title || "";
    this.articleCompany = obj.company || "";
    this.articleAuthor = obj.author || "";
    //UNIX时间戳转义
    this.articleTime = this.formatTime(obj.time || "");
    this.isFile = (obj.isFile == 1 || obj.isFile == "1") || false;
    this.target = obj.target || null;
    this.attachments = obj.attachments || [];

    if(!this.isFile){
      this.content = document.querySelector("#rich_content").innerHTML || "";
      document.querySelector("#rich_content").innerHTML = "";
    }
    
    if(obj.reportObj){
      // this.domain = obj.reportObj.domain || "";
      this.companyId = obj.reportObj.companyId || "";
      this.tType = obj.reportObj.tType || "";
      this.tId = obj.reportObj.tId || "";
      this.getCount();
    }


  },

  mounted () {
    this.checkRid();
    setTimeout(() => {
      this.reportData();
    },2000);
  },

  methods: {
    reportData () {
      if(!(this.domain && this.companyId && this.tType && this.tId)){
        return;
      }
      axios.get("//" + this.domain + '/gapi/v1/open/pv-report', {
        params: {
          companyId: this.companyId, 
          tType: this.tType, 
          tId: this.tId
        },
        headers: {"X-MP":"self"},
        withCredentials: true
      })
      .then(function (response) {
        
      })
      .catch(function (error) {
        
      });
    },

    checkRid () {
      let rid = cookieClient.get('ext_ruuid');
      if(!rid){
        let curTime = String(this.getCurUnixTime());
        let r = String(Math.round(Math.random() * 100000));
        cookieClient.set('ext_ruuid', curTime + r, { expires: 180, domain:this.fdomain, path: '/open/'});
        cookieClient.set('ext_ruuid', curTime + r, { expires: 180, domain:this.fdomain, path: '/gapi/v1/open/'});
        //cookieClient.set('ext_ruuid', curTime + r, { expires: 180});
      }
    },

    getCount () {
      if(!(this.domain && this.companyId && this.tType && this.tId)){
        return;
      }
      axios.get("//" + this.domain + '/gapi/v1/open/read-count', {
        params: {
          companyId: this.companyId, 
          tType: this.tType, 
          tId: this.tId
        },
        headers: {"X-MP":"self"},
        withCredentials: true
      })
      .then((response) => {
        let data = response.data;
        if(data && data.code == 0 && data.data){
          this.pageCount = data.data.read_count || 1;
        }else{
          this.pageCount = 1;
        }
      })
      .catch((error) => {
        this.pageCount = 1;
      });    
    },

    /**
     * 获取当前的unix时间戳
     */
    getCurUnixTime : () => {
      let curTime = new Date().getTime();
		  return curTime;
    },

    /**
     * 将unix 时间戳转换成符合可读的时间格式"2013-01-03 11:22:30"
     * @param t {number}
     */
    formatTime (t,onlyDate) {
      if(typeof t == "string"){
        return t;
      }
      let d = new Date(t*1000);
      let year = d.getFullYear();
      let month = String(d.getMonth() + 1);
      if(parseInt(month) < 10){
          month = "0" + month;
      }
      let date = String(d.getDate());
      if(parseInt(date) < 10){
          date = "0" + date;
      }
      let y_m_d = [year, month, date].join('-');
      //当前时分秒
      let hour = String(d.getHours());
      if(parseInt(hour) < 10){
          hour = "0" + hour;
      }
      let minute = String(d.getMinutes());
      if(parseInt(minute) < 10){
          minute = "0" + minute;
      }
      let second = String(d.getSeconds());
      if(parseInt(second) < 10){
          second = "0" + second;
      }
      let h_m_s = [hour,minute,second].join(":");
      if(onlyDate === true){
          //只返回日期
          return y_m_d;
      }else{
          //返回日期和时间
          return y_m_d + " " + h_m_s;
      }
    },
    
  }

}
</script>

